import {Component, Input, OnInit} from '@angular/core';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {SyncMember} from '@gt-api';
import {GtNotificationService} from '@app/services/gt-notification.service';
import {TranslateService} from '@ngx-translate/core';
import {GtSynchronizationService} from '@app/services/gt-synchronization.service';
import {catchError, tap} from 'rxjs/operators';
import {EMPTY} from 'rxjs';

@Component({
  selector: 'gt-ews-sync-settings',
  templateUrl: './ews-sync-settings.component.html',
  styleUrls: ['./ews-sync-settings.component.scss']
})
export class EwsSyncSettingsComponent implements OnInit {
  syncActive: boolean;
  syncMember: SyncMember;
  @Input() login: string;
  @Input() oname: string;
  @Input() canEdit = true;

  constructor(
    private authSer: GtAuthenticationService,
    private synchronizationService: GtSynchronizationService,
    private notificationService: GtNotificationService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.login = this.login ? this.login : this.authSer.login;
    this.oname = this.oname ? this.oname : this.authSer.oname;
    this.getSyncStatus();
  }

  getSyncStatus() {
    this.synchronizationService.getSyncMembers(this.oname, this.login).pipe(
      tap(members => {
        if (members) {
          this.syncMember = members.find(sm => {
            return sm.login === this.login && sm.organization === this.oname;
          });
          if (this.syncMember) {
            this.syncActive = !this.syncMember.deactivatedAbsence;
          } else {
            this.serviceNotAvailable();
          }
        }
      }),
      catchError(error => {
        this.serviceNotAvailable();
        console.error('Failed to getSyncMembers', error);
        return EMPTY;
      })
    ).subscribe();
  }

  private serviceNotAvailable() {
    this.notificationService.errorNotification.next(this.translateService.instant('global.service_not_available'));
  }

  private error(error: any) {
    this.notificationService.errorNotification.next(error);
  }

  setSyncActive(syncActive: boolean) {
    this.syncActive = syncActive;
    this.syncMember.deactivatedAbsence = this.syncActive ? null : new Date();
    this.synchronizationService.editSyncMember(this.oname, this.login, this.syncMember).pipe(
      catchError(error => {
        this.error(error);
        this.getSyncStatus();
        return EMPTY;
      })
    ).subscribe();
  }
}
